import { useTranslation } from "react-i18next";

import { Tooltip, IconButton, CircularProgress } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import RefreshIcon from "@mui/icons-material/Refresh";

interface Props {
  onClick: () => void;
  isLoading?: boolean;
  tooltipTitle?: string;
}

const useStyles = makeStyles(() => ({
  circularProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 1,
  },
}));

export default function RefreshLoadingButton(props: Props) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Tooltip title={props.tooltipTitle || t<string>("common.refreshData")}>
      <span>
        <IconButton onClick={props.onClick} disabled={props.isLoading} size="large">
          <RefreshIcon color={props.isLoading ? "disabled" : "primary"} />

          {props.isLoading && <CircularProgress size={48} color="primary" className={classes.circularProgress} />}
        </IconButton>
      </span>
    </Tooltip>
  );
}
